import { Grid } from "@mui/material";
import { ShowBase } from "ra-core";
import { FC } from "react";
import { Content } from "~/components/content/Content";
import { OdResourcePageProps } from "~/types/resource";
import { CreateFileCatalogTile, CreateFileAuditTile, CreateFileClassificationTile, CreateFileOwnershipTile } from "~/components/securefiles/entryTiles";
import SecureFilesTable from "~/components/securefiles/SecureFileUpdatesTable";

const SecureFileDashboard: FC<OdResourcePageProps> = () => {


  return (
    <ShowBase resource="secure-files/dashboard" basePath="" id="-1" >
      <Content pageName="SecureFile Dashboard" resourceName="SecureFile Dashboard">
        <Grid container spacing={4} sx={{ pt: 2 }}>
          <Grid item xs={12} sm={6} md={3}>
            <CreateFileCatalogTile />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <CreateFileAuditTile />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <CreateFileClassificationTile />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <CreateFileOwnershipTile />
          </Grid>

          <Grid item xs={12}>
            <SecureFilesTable />
          </Grid>
        </Grid>
      </Content>
    </ShowBase>
  )
}

export default SecureFileDashboard;

